import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import CommonTooltip from '../../../../../components/common-tooltip/CommonTooltip';

import scss from './NavTab.module.scss';

function NavTab({ icon: Icon, label, isActive, isComingSoon, onClick }) {
  const { t } = useTranslation('mediaStudio');
  const content = (
    <>
      <Icon size={18} strokeWidth={2} />
      <span className={scss.navLabel}>{label}</span>
    </>
  );

  if (isComingSoon) {
    return (
      <CommonTooltip title={t('comingSoon')} placement='right'>
        <span className={scss.navItemWrap}>
          <button type='button' role='tab' aria-selected={false} className={scss.navItem} disabled>
            {content}
          </button>
        </span>
      </CommonTooltip>
    );
  }

  return (
    <button
      type='button'
      role='tab'
      aria-selected={isActive}
      className={clsx(scss.navItem, isActive && scss.navItemActive)}
      onClick={onClick}
      title={label}>
      {content}
    </button>
  );
}

export default NavTab;
